var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('cv-header'),_c('v-main',{staticStyle:{"position":"relative"}},[_c('v-img',{staticClass:"rec-login-bg",attrs:{"src":_vm.src}}),_c('div',{staticClass:"login-wrap"},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }